module.exports = __webpack_public_path__ + "assets/img/facergt-offlinestr.129b903d.png";